module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar2-81af40ae.svg";